import { AuditHistory } from "./components/AuditHistory";

export default AuditHistory;